import { ServiceAppointmentStatus } from '../../core/data-models/service-appointment-status.model';

/**
 * Status display info
 *
 * Colors:
 * - pending/requested: warning (yellow) - awaiting action
 * - scheduled: info (blue) - scheduled
 * - confirmed: primary (blue) - confirmed
 * - in_progress: info (blue) - active
 * - completed: success (green) - done
 * - cancelled: secondary (gray) - cancelled
 */
export const SERVICE_APPOINTMENT_STATUSES: { value: ServiceAppointmentStatus; label: string; color: string }[] = [
  { value: 'pending', label: 'Pending', color: 'warning' },
  { value: 'requested', label: 'Pending', color: 'warning' }, // deprecated, maps to same display as pending
  { value: 'scheduled', label: 'Scheduled', color: 'info' },
  { value: 'confirmed', label: 'Confirmed', color: 'primary' },
  { value: 'in_progress', label: 'In Progress', color: 'info' },
  { value: 'completed', label: 'Completed', color: 'success' },
  { value: 'cancelled', label: 'Cancelled', color: 'secondary' }
];

/**
 * Preferred time options for UI
 */
export const PREFERRED_TIME_OPTIONS: { value: string; label: string }[] = [
  { value: 'morning', label: 'Morning (8am-12pm)' },
  { value: 'afternoon', label: 'Afternoon (12pm-4pm)' },
  { value: 'evening', label: 'Evening (4pm-7pm)' },
  { value: 'anytime', label: 'Anytime' }
];
